import React from 'react';

// project-imports
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import StencilBox from '../../components/stencils/StencilBox';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import ContactUsFormStencil from '../../components/contact/ContactUsFormStencil';


const ContactUsStencil = ({ stencilLoading }) => {
    return (
        <>

            <SEO title="Contact Us" isCrawlable={false} /> {/* Set SEO title */}
            <Layout>
                <BreadcrumbOne
                    title="Contact Us" // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Contact Us"
                />
                <div className="eduvibe-contact-us edu-contact-us-area edu-section-gap bg-color-white">
                    <div className="container eduvibe-animated-shape">
                        <div className="row g-5">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <StencilBox
                                        width="100%"
                                        height="26px"
                                        backgroundColor="#EEF1F6"
                                    />
                                    <StencilBox
                                        width="100%"
                                        height="56px"
                                        backgroundColor="#EEF1F6"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row g-5 mt--20">
                            <div className="col-lg-6">
                                <div className="contact-info pr_lg--0 pr_md--0 pr_sm--0">
                                    <div className="row g-5">
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 d-flex">
                                            <StencilBox
                                                width="100%"
                                                height="248.08px"
                                                backgroundColor="#EEF1F6"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 d-flex">

                                            <StencilBox
                                                width="100%"
                                                height="248.08px"
                                                backgroundColor="#EEF1F6"
                                            />

                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 d-flex">
                                            <StencilBox
                                                width="100%"
                                                height="248.08px"
                                                backgroundColor="#EEF1F6"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 d-flex">
                                            <StencilBox
                                                width="100%"
                                                height="248.08px"
                                                backgroundColor="#EEF1F6"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <ContactUsFormStencil formStyle="rnt-contact-form rwt-dynamic-form row" />
                            </div>
                        </div>

                        <div className="shape-dot-wrapper shape-wrapper d-xxl-block d-none">
                            <div className="shape-image shape-image-1">
                                <img src="/images/shapes/shape-04-01.png" alt="Shape Thumb" />
                            </div>
                            <div className="shape-image shape-image-2">
                                <img src="/images/shapes/shape-02-08.png" alt="Shape Thumb" />
                            </div>
                            <div className="shape-image shape-image-3">
                                <img src="/images/shapes/shape-15.png" alt="Shape Thumb" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="edu-contact-map-area edu-section-gapBottom">
                    <div className="container mb--80">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="google-map alignwide">
                                    <StencilBox
                                        width="100%"
                                        height="500px"
                                        backgroundColor="#EEF1F6"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}
export default ContactUsStencil;